import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CompartmentOverviewFacade } from './compartment-overview.facade';
import { CompartmentItemFacade } from '../compartment-item.facade';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';
@Injectable({
  providedIn: 'root',
})
export class CompartmentOverviewGuard {
  constructor(
    private compartmentItemFacade: CompartmentItemFacade,
    private compartmentOverviewFacade: CompartmentOverviewFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.compartmentItemFacade.compartmentId$.pipe(
      switchMap((id: number) => {
        return checkStoreState(this.compartmentOverviewFacade, id);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentOverviewFacade);
  }
}
